const doc = [({"searchLabel":"Cherchez par nom de club", "boxTitle":"Nous avons généré cet article pour vous", "signature":"Mathieu Signorell avec l’aide du robot Tobi"})];
module.exports = doc.length <= 1 ? doc[0] : doc;